export default __webpack_public_path__ + "static/media/logo.de483d64.png";